import sagaPlugin from './saga';

export default sagaPlugin;

export { keaSaga } from './saga/saga';


//////////////////
// WEBPACK FOOTER
// ./node_modules/kea-saga/es/index.js
// module id = 70
// module chunks = 0